import { TextField, Select as SelectMUI, MenuItem } from '@material-ui/core'
import React, { useCallback } from 'react'
import {  mdiFilePdfBox, mdiMagnify, mdiMicrosoftExcel } from '@mdi/js'
import Section, { SectionBox, SectionOption } from '../../../../components/Section'
import { Link } from 'react-router-dom'
import TableListarRelatorio from './components/TableListarRelatorio'
import { useDispatch } from 'react-redux'
import { useAppSelector } from '../../../../store/hooks'
import { setAno, setIdFiltered } from './Reducers/RelatorioRankingReducer'
import filter from './scripts/filter'
import { defaultRelatorioExcel } from '../../../../scripts/defaultRelatorioExcel'

const RelatorioRanking: React.FC = () => {

  const dispatch = useDispatch()
  const {filteredLista ,requestFilter , ano, idFiltered}= useAppSelector(state => state.RelatorioRankingReducer)

    const handleFilter = useCallback(async () => {
        filter(dispatch,ano, idFiltered)
    }, [dispatch, ano,idFiltered])
 


    const keyPress =(async (e:any) => {
        if(e.keyCode === 13){
            handleFilter()
         }
    }) 

    return (
        <>
            <Section name = "NameSection">
                <SectionBox 
                    title = {"RELAÇÃO DE INDÚSTRIAS INTERLIGADAS À ETEJ"}
                    padding = {false} 
                    right = {
                        <>
                            <TextField id="filterDescricao" variant="standard" type={"text"} className="fieldFilter" placeholder="Ano de consulta" onKeyPress={keyPress} defaultValue={ano} onChange={(e)=> dispatch(setAno(e.target.value as string))}  />

                            <SelectMUI id="filterAtivo" value={idFiltered} onChange={e => dispatch(setIdFiltered(e.target.value as any))}>
                                <MenuItem value={1}>Mínimo de Coletas</MenuItem>
                                <MenuItem value={2}>Coletas realizadas</MenuItem>
                                <MenuItem value={3}>Meta</MenuItem>
                            </SelectMUI>
                            <SectionOption icon = {mdiMagnify} tooltip = "Filtrar" onClick = {handleFilter} />
                            <Link to = "pdf" target = "_blank">
                                <SectionOption icon = {mdiFilePdfBox} tooltip = "Visualizar PDF" onClick = {() => {}} />
                            </Link>

                            <SectionOption icon = {mdiMicrosoftExcel} tooltip = "Baixar Excel" onClick = {() => {defaultRelatorioExcel(filteredLista, 'Relatorio_ranking')}} />
                        </>
                    }
                >
                    {!!filteredLista && !requestFilter.loading &&
                    <>
                    <TableListarRelatorio
                    lista={filteredLista}
                    loading={requestFilter.loading}
                    />
                    </>
                    }
                </SectionBox>
            </Section>

        </>
    )
}

export default RelatorioRanking

